import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Box, CssBaseline } from '@mui/material';
import { styled } from '@mui/system';
import NavbarAdmin from '../navbar/NavbarAdmin';
import SidebarAdmin from '../sidebar/SidebarAdmin';



//size drawer
const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
}));


const Layout = ({ darkMode, setDarkMode }) => {
    //state -> open sidebar
    const [openSidebar, setOpenSidebar] = useState(false);

    //function -> to open sidebar
    const handleSidebarOpen = () => {
        setOpenSidebar(true);
    };
    //function -> to close sidebar
    const handleSidebarClose = () => {
        setOpenSidebar(false);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <NavbarAdmin
                openSidebar={openSidebar}
                handleSidebarOpen={handleSidebarOpen}
                darkMode={darkMode}
                setDarkMode={setDarkMode}
            />
            <SidebarAdmin
                openSidebar={openSidebar}
                handleSidebarClose={handleSidebarClose}
                drawerWidth={drawerWidth}
                DrawerHeader={DrawerHeader}
            />

            <Main open={openSidebar}>
                <DrawerHeader />
                <Outlet />
            </Main>
        </Box>
    )
}
export default Layout;